import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SliderSwitchModule, TravisBuildModule, TranslateModule } from '@xref/ngx';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    TranslateModule,
    CommonModule,
    TravisBuildModule,
    SliderSwitchModule
  ],
  exports: [FooterComponent],
  declarations: [FooterComponent]
})
export class FooterModule {}
